import { connect } from 'react-redux'
import { Field } from 'redux-form'
import React, { Component } from 'react'
import { TableColumn, TableRow } from 'react-md'

import { TextField } from 'components'
import { getSize } from 'redux/reducers'

class ListRow extends Component {
  constructor (props) {
    super(props)

    this.getField = this.getField.bind(this)
    this.getTotal = this.getTotal.bind(this)
    this.handleRowClick = this.handleRowClick.bind(this)
  }

  getField (fieldName) {
    const { fields, index } = this.props

    if (!fields || !fields.get(index)) {
      return null
    }

    return fields.get(index)[fieldName]
  }

  getTotal () {
    let markup

    if (this.getField('isCustom')) {
      markup = this.getField('commission')
    } else {
      markup = this.getField('defaultCommission')
    }

    const basePrice = this.getField('basePrice') || 0
    const vat = this.getField('vat') || 0

    const total = (Number(markup) + Number(basePrice)) * (1 + Number(vat))

    return total.toFixed(2)
  }

  handleRowClick (event) {
    const { change, member } = this.props
    const isCustom = this.getField('isCustom')
    if (!isCustom) {
      const markup = this.getField('defaultCommission')
      change(`${member}.isCustom`, !isCustom)
      change(`${member}.commission`, markup)
    }
  }

  render () {
    const { frameType, form, member, readOnly, size } = this.props

    const isCustom = this.getField('isCustom')
    const defaultCommission = this.getField('defaultCommission')
    const visible = this.getField('frameTypeId') === frameType

    return (
      <TableRow
        onClick={this.handleRowClick}
        className={visible ? '' : 'hidden'}
      >

        <TableColumn plain={false}>
          { size.name }
        </TableColumn>

        <TableColumn numeric plain={false}>
          &pound; { this.getField('basePrice') }
        </TableColumn>

        <TableColumn className='markup' plain={false}>
          { isCustom ? (
            <Field
              id={`${form}-${member}.commission`}
              name={`${member}.commission`}
              type='number'
              min={0}
              step={0.01}
              fullWidth={false}
              className='price'
              component={TextField}
              disabled={readOnly}
            />
          ) : (
            <div className='default-markup'>&pound; {defaultCommission}</div>
          ) }
        </TableColumn>

        <TableColumn numeric plain={false}>
          <div>&pound; { `${this.getTotal()}` }</div>
        </TableColumn>

      </TableRow>
    )
  }
}

const mapStateToProps = (state, { fields, index }) => ({
  size: fields.get(index) ? getSize(state, fields.get(index).sizeId) : null
})

export default connect(mapStateToProps)(ListRow)



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/CommissionsView/CommissionList/ListRow.js